import { React, useEffect, useState } from "react";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import { SimpleSelect } from "../../ConfigurarLeads/SimpleSelect";

const ESTADO_OPCIONES = [
    { value: "true", label: "Activo" },
    { value: "false", label: "Inactivo" },
];

const camposIniciales = {
    idgrupoactividades: -999,
    nombregrupoactividades: "",
    estado: true,
    usuario: 1,
};

// Modal único para Alta y Edición de Cat_GrupoActividades.
export const GrupoActividadModal = ({ open, onClose, editId = null, onSaved }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [form, setForm] = useState(camposIniciales);

    const esEdicion = !!editId;

    useEffect(() => {
        if (!open) return;

        if (!editId) {
            setForm(camposIniciales);
            return;
        }

        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get(`GrupoActividades/Obtener/${editId}`)
            .then((result) => {
                setForm({ ...result, usuario: 1 });
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("GRUPO ACTIVIDADES", "No se pudo cargar el grupo", "error");
            });
    }, [open, editId]);

    const validar = () => {
        if (!form.nombregrupoactividades || !form.nombregrupoactividades.trim()) {
            Swal.fire("GRUPO ACTIVIDADES", "El nombre es obligatorio", "warning");
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (!validar()) return;
        setLoader((prev) => ({ ...prev, mostrar: true }));

        request
            .post("GrupoActividades/Guardar", form)
            .then(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire(
                    "GRUPO ACTIVIDADES",
                    esEdicion ? "Grupo actualizado correctamente" : "Grupo guardado correctamente",
                    "success"
                );
                onSaved && onSaved();
                handleCancelar();
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("ERROR", "No se pudo guardar el grupo", "error");
            });
    };

    const handleCancelar = () => {
        setForm(camposIniciales);
        onClose();
    };

    return (
        <Modal open={open} onClose={handleCancelar}>
            <div className="grupo-act-modal-formulario">
                <div className="grupo-act-modal-plantilla">
                    <div className="plantilla-screen-filtro-container" id="grupo-act-modal">
                        <PlantillaScreen
                            titulo={esEdicion ? "EDITAR GRUPO DE ACTIVIDADES" : "NUEVO GRUPO DE ACTIVIDADES"}
                            className_main={1}
                            className="plantilla-screen-filtro-container-modal"
                        >
                            <div className="cerrar-modal-button" onClick={handleCancelar}>X</div>
                            <LoaderScreen loader={loader} />
                            <div className="grupo-act-modal-content">
                                <div className="grupo-act-modal-content-container scroll-4">
                                    <div className="lead-form-group">
                                        <label>Nombre del grupo</label>
                                        <input
                                            type="text"
                                            value={form.nombregrupoactividades}
                                            onChange={(e) =>
                                                setForm((prev) => ({ ...prev, nombregrupoactividades: e.target.value }))
                                            }
                                            maxLength={30}
                                            placeholder="Ej. Soporte técnico"
                                        />
                                    </div>
                                    <div className="lead-form-group">
                                        <label>Estado</label>
                                        <SimpleSelect
                                            options={ESTADO_OPCIONES}
                                            value={form.estado ? "true" : "false"}
                                            onChange={(val) => setForm((prev) => ({ ...prev, estado: val === "true" }))}
                                            placeholder="Seleccione el estado"
                                        />
                                    </div>
                                </div>
                                <div className="grupo-act-modal-buttons">
                                    <button
                                        className="grupo-act-modal-button-cancelar"
                                        onClick={handleCancelar}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        className="grupo-act-modal-button-guardar"
                                        onClick={handleGuardar}
                                        disabled={loader.mostrar}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default GrupoActividadModal;
